import { EInputMode } from '../../AddressCadastreFieldContainer';
import { EObjectTypeOptions, IRequestFormValue } from '../../../types/requestFormValue';

/**
 * Вычисляем значение активного таба (режима ввода) в инпуте AddressCadastre на основании значения полей формы.
 */
export function getDefaultInputMode(values: IRequestFormValue): EInputMode {
  const { addressCadastre, objectType } = values;

  // если есть значение - покажем таб с пользовательским вводом
  if (addressCadastre) {
    return addressCadastre.cadastre ? EInputMode.Cadastre : EInputMode.Address;
  }

  // по умолчанию покажем таб по типу обьекта
  return objectType && [EObjectTypeOptions.Land, EObjectTypeOptions.House].includes(objectType)
    ? EInputMode.Cadastre
    : EInputMode.Address;
}
